const breakpoints = {
  tablet: "600px"
}

const theme = {
  breakpoints
}

export default theme;